import React from 'react';
import { Page } from '../Page';
import { Heart, Activity, ShieldPlus, Apple } from 'lucide-react';
import { SupplementCallout } from '../SupplementCallout';
export function Page8() {
  return <Page pageNumber={19} variant="light" data-id="element-647">
      <div className="flex flex-col h-full" data-id="element-648">
        <div className="h-[180px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-649">
          <img src="https://images.unsplash.com/photo-1610348725531-843dff563e2c?w=1000&q=80" alt="Colorful high-fiber vegetables and fruits" className="w-full h-full object-cover" data-id="element-650" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-[#F5F5F0]/40 to-transparent" data-id="element-651" />
        </div>

        <div className="mb-6 pt-0" data-id="element-652">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-653">
            The Essentials
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-654">
            <span className="text-tealslate" data-id="element-655">Fiber</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-656" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-657">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-658">
            GLP-1 medications slow down your digestion. While this keeps you
            full, it also creates the most common side effect: constipation.
            Fiber is your primary defense.
          </p>
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-659">
            <h3 className="text-xs font-bold text-tealslate uppercase tracking-wider mb-3" data-id="element-660">
              Recommended Daily Intake
            </h3>
            <div className="flex gap-8" data-id="element-661">
              <div data-id="element-662">
                <span className="text-3xl font-serif text-tealslate" data-id="element-663">25g</span>
                <span className="text-xs text-[#7A7A70] ml-2" data-id="element-664">women</span>
              </div>
              <div data-id="element-665">
                <span className="text-3xl font-serif text-tealslate" data-id="element-666">38g</span>
                <span className="text-xs text-[#7A7A70] ml-2" data-id="element-667">men</span>
              </div>
            </div>
          </div>
        </div>

        <h2 className="text-lg font-serif text-[#1F1F1F] mb-4" data-id="element-668">
          Great Food Sources
        </h2>
        <div className="flex flex-wrap gap-2 mb-8" data-id="element-669">
          {['Beans', 'Lentils', 'Broccoli', 'Berries', 'Oats', 'Chia Seeds', 'Avocado', 'Apples', 'Brussels Sprouts'].map((item, i) => <div key={i} className="bg-[#EAEAE4] border border-[#D8D8D0] px-4 py-2 text-xs text-[#1F1F1F] font-medium flex items-center gap-2" data-id="element-670">
              <Apple className="w-3 h-3 text-tealslate" data-id="element-671" />
              {item}
            </div>)}
        </div>

        <div className="grid grid-cols-4 gap-4 mb-6" data-id="element-672">
          {[{
          icon: ShieldPlus,
          label: 'Gut Health'
        }, {
          icon: Activity,
          label: 'Blood Sugar'
        }, {
          icon: Apple,
          label: 'Satiety'
        }, {
          icon: Heart,
          label: 'Heart Health'
        }].map((item, i) => <div key={i} className="text-center" data-id="element-673">
              <div className="w-10 h-10 rounded-full bg-tealslate/20 border border-tealslate/40 flex items-center justify-center mx-auto mb-2" data-id="element-674">
                <item.icon className="w-5 h-5 text-tealslate" data-id="element-675" />
              </div>
              <span className="text-[10px] font-bold text-[#1F1F1F] uppercase tracking-wider" data-id="element-676">
                {item.label}
              </span>
            </div>)}
        </div>

        <SupplementCallout title="Fiber Supplement" description="Inulin fiber is a well-tolerated option for increasing daily intake. Take it with meals to improve absorption." data-id="element-677" />
      </div>
    </Page>;
}